import { render } from "./Help.vue?vue&type=template&id=3f809fb0&ts=true"
import script from "./Help.vue?vue&type=script&lang=ts"
export * from "./Help.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/Windows/Help.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3f809fb0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3f809fb0', __exports__)) {
    api.reload('3f809fb0', __exports__)
  }
  
  module.hot.accept("./Help.vue?vue&type=template&id=3f809fb0&ts=true", () => {
    api.rerender('3f809fb0', render)
  })

}


export default __exports__